package pl.zar.tikthrow.ui.media

import org.w3c.files.File

actual object MediaFileRegistry {
    private val files = mutableMapOf<String, Any>()

    actual fun register(uri: String, file: Any) {
        files[uri] = file
    }

    actual fun file(uri: String): Any? = files[uri]
}
